import Helmet from 'react-helmet'
import IconButton from 'material-ui/IconButton'
import DoneIcon from 'material-ui/svg-icons/action/done'
import WarningIcon from 'material-ui/svg-icons/alert/warning'
import DangerIcon from 'material-ui/svg-icons/content/clear'
import { Link } from 'react-router'
import { Nav, EditTitleDescriptionPanel, Loading } from 'components'
import { AnalyticsUtils, TemplateUtils, Enum } from 'utils'

import './titleDescriptionPage.scss'

const SEVERITY_ICONS = [
  <DoneIcon color="#49A74C" style={{ width: 16, height: 16 }} />,
  <WarningIcon color="#FFBD36" style={{ width: 16, height: 16 }} />,
  <DangerIcon color="#FF4141" style={{ width: 16, height: 16 }} />
]

const templates = [  
  { title: 'Homepage', resourceName: 'Index', pathName: 'index' },
  { title: 'Collections', resourceName: 'Collection', pathName: 'collection' },
  { title: 'Products', resourceName: 'Product', pathName: 'product' },
  { title: 'Pages', resourceName: 'Page', pathName: 'page' },
  { title: 'Articles', resourceName: 'Article', pathName: 'article' },
  { title: 'Blog', resourceName: 'Blog', pathName: 'blog' },  
  { title: 'Catalog', resourceName: 'Catalog', pathName: 'catalog' },
  { title: 'Search', resourceName: 'Search', pathName: 'search' },
  { title: '404 Page', resourceName: '404', pathName: '404' },
  { title: 'Other', resourceName: 'Default', pathName: 'default' }
]

export default class TitleDescriptionPage extends React.Component {
  static contextTypes = {
    muiTheme: React.PropTypes.object.isRequired
  }

  static propTypes = {
    settings:         React.PropTypes.object,
    fetching:         React.PropTypes.bool,
    previews:         React.PropTypes.array,
    fetchingPreviews: React.PropTypes.bool,
    installed:        React.PropTypes.bool,
    status:           React.PropTypes.object,
    handleRequestInstall: React.PropTypes.func.isRequired,
    currentUser:      React.PropTypes.object.isRequired,
  }

  state = {
    activeTemplate: templates[0]
  }

  renderTemplatePageItem(template) {
    const { title, resourceName, pathName } = template;
    const { settings } = this.props
    const { activeTemplate } = this.state
    const className = activeTemplate.pathName === pathName ?
                        'title-n-desc__nav__item active' :
                        'title-n-desc__nav__item'

    if (!settings) {
      return (
        <li
          key={resourceName}
          className={className}
          onTouchTap={() => this.setState({ activeTemplate: template })}
        >
          {title}
        </li>
      )
    }

    let criticality
    const titleTemplateStr = settings[`pageTitle${resourceName}Template`]
    const descriptionTemplateStr = settings[`metaDescription${resourceName}Template`]

    if (resourceName === 'Index') {
      criticality = titleTemplateStr && descriptionTemplateStr ? 0 : 2
    } else {
      const titleCriticality = TemplateUtils.getCriticality(titleTemplateStr,
                                                            Enum.TitleTemplateFormula[resourceName],
                                                            Enum.TitleTemplateChecklist[resourceName])
      const descriptionCriticality = TemplateUtils.getCriticality(descriptionTemplateStr,
                                                                  Enum.DescriptionTemplateFormula[resourceName],
                                                                  Enum.DescriptionTemplateChecklist[resourceName])
      criticality = Math.max(titleCriticality, descriptionCriticality)
    }

    return (
      <li
        key={resourceName}
        className={className}
        onTouchTap={() => this.setState({ activeTemplate: template })}
      >
        {SEVERITY_ICONS[criticality]}
        <span>{title}</span>
      </li>
    )
  }

  render() {
    const { activeTemplate: { title, pathName, resourceName } } = this.state
    const palette = this.context.muiTheme.palette

    if (!this.props.settings) {
      return (
        <div>
          <Helmet title="Plug in SEO Plus" />
          <Nav toolbarTitleText="Page Titles and Meta Descriptions" />
          <Loading />
        </div>
      )
    }

    return (
      <div>
        <Helmet title="Plug in SEO Plus" />
        <Nav
          toolbarTitleText="Page Titles and Meta Descriptions"
          rightGroupComponents={[
            <a href="https://support.pluginuseful.com/hc/en-us/articles/23534794236820-Fix-It-SEO-Page-Titles" target="_blank">
              <IconButton 
                tooltip='Learn More' 
                iconClassName="material-icons"
                iconStyle={{ color: palette.alternateTextColor }}
              >
                info_outline
              </IconButton>
            </a>,
            <Link key='settings' to="/plus/title-description/settings">
              <IconButton
                tooltip='Settings'
                iconClassName="material-icons"
                iconStyle={{ color: palette.alternateTextColor }}
              >
                settings
              </IconButton>
            </Link>
          ]}
        />
        <div className="title-n-desc">
          <ul className="title-n-desc__nav">
            {templates.map(template => this.renderTemplatePageItem(template))}
          </ul>
          <div className="title-n-desc__content">
            <EditTitleDescriptionPanel
              key={resourceName}
              title={title}
              resourceName={resourceName}
              resource={pathName}
              {...this.props}
            />   
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/pages/plus/TitleDescriptionPage.js